import React from 'react';

export default class LoadableIcon extends React.PureComponent {
  render() {
    return (
      <span>
        <img
          src="/assets/loading.gif"
          style={this.props.loading ?
            { height: '12px', paddingBottom: '1px' } :
            { display: 'none' }
          }
        />
        <i
          className={`fa ${this.props.icon}`}
          style={this.props.loading ? { display: 'none' } : {}}
          aria-hidden>
        </i>
      </span>
    );
  }
}
